module.exports = __webpack_public_path__ + "static/introduction_img5@2x-bd1d751a83aee6578c3412f74e6f8c0e.jpg";